import { Component, OnInit, Optional, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService, AccountMembership, AuthorizationLevel, Team, TeamMember, UpdateAccountInput } from 'app/API.service.custom';
import { AddContactComponent } from 'app/shared/add-contact/add-contact.component';
import { TeamInboxComponent } from 'app/shared/conversation/team-inbox/team-inbox.component';
import { AddEmployeeBulkComponent } from 'app/shared/employee/add-employee-bulk/add-employee-bulk.component';
import { InviteToGroupNewComponent } from 'app/shared/employee/invite-to-group-new/invite-to-group-new.component';
import { QuotationDefaultsComponent } from 'app/shared/product/quotation-defaults/quotation-defaults.component';
import { WorkPipelineSetupComponent } from 'app/shared/work-pipeline/work-pipeline-setup.component';
import { isFeatureEnabled } from 'app/core/feature-flags';
import { CreatePropertyComponent } from 'app/shared/properties/create-property/create-property.component';
import { CreateTemplateComponent } from 'app/shared/templates/create-template/create-template.component';
import { actionDetails, actions } from 'globals/constants';
import _ from 'lodash-es';
import { DialogConfig, DialogRef, DialogService } from 'app/shared/dialog';
import { DataShareService } from 'services/data-share.service';
import { AppHealthDiagnosticService } from 'app/shared/admin/app-install-status/app-health-diagnostic.service';
import {
  canAdministerGeofences as canAdministerGeofencesForAccount,
  canCustomizeWorkspace as canCustomizeWorkspaceForAccount,
} from 'app/core/access/route-access-policy';
import Swal from 'sweetalert2';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { isValidGstin } from '../../account/gstin';

@Component({
    selector: 'app-admin-actions',
    templateUrl: './admin-actions.component.html',
    styleUrls: ['./admin-actions.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, NgxSkeletonLoaderModule, MatButton, MatIcon]
})
export class AdminActionsComponent implements OnInit {
  activeAccountSubscription;
  allUserMembershipsSubscription;
  teamMembershipsSubscription;
  teamsSubscription;

  activeAccount: AccountMembership = null;
  fetchedUserMemberships: AccountMembership[] = [];

  fetchedTeamMemberships: TeamMember[] = [];
  fetchedTeams: Team[] = [];

  searchForm_activity: UntypedFormGroup;
  action = null;
  actionDetail = null;
  actionsOriginal = actions
  actionDetailsOriginal = actionDetails;
  requestSubmitted = false;
  actions = null;
  actionDetails = null;
  callingApi = false;
  searchValue = null;
  searchHasRun = false;
  showSuggestion = true;
  suggestionText = null;

  channeId = null;
  appIssueCount = 0;

  constructor(
    private router: Router,
    private dialogService: DialogService,
    @Optional() private config: DialogConfig,
    @Optional() private dialog: DialogRef,
    private dataService: DataShareService,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private api: APIService,
    private sanitizer: DomSanitizer,
    private diagnosticService: AppHealthDiagnosticService,
  ) { }

  createForm_search_activity() {
    this.searchForm_activity = this.formBuilder.group({
      'search_activity': ['', []]
    });
  }

  onEnter() {
    this.searchValue = this.searchForm_activity.get('search_activity').value;
    if (this.searchValue?.trim()) {
      this.openUnifiedAssistant(this.searchValue.trim());
    }
  }

  suggestedSearch(text) {
    this.searchValue = text;
    this.searchForm_activity.get('search_activity').setValue(text);
    this.searchForm_activity.get('search_activity').updateValueAndValidity(text);
    this.getAction(this.searchValue);
  }

  clearActivitySearchField(clearSearchField: boolean) {
    if (clearSearchField) {
      this.searchForm_activity.get('search_activity').setValue('', { emitEvent: false });
      this.action = null;
      this.actionDetail = null;
      this.requestSubmitted = false;
      this.searchValue = null;
      this.searchHasRun = false;
    }
  }

  getAction(input?: string) {
    this.actions = _.cloneDeep(this.actionsOriginal);
    this.actionDetails = _.cloneDeep(this.actionDetailsOriginal);
    if (input && input != '' && !this.requestSubmitted) {
      this.callingApi = true;
      this.requestSubmitted = true;
      this.actionDetail = null;
      this.showSuggestion = false;
      this.suggestionText = null;
      this.searchHasRun = false;
      console.log("Input before api call is ", input);
      this.api.MapDataFields(JSON.stringify(input), JSON.stringify("ADMIN_ACTION"), this.activeAccount?.accountId, this.activeAccount?.userId).then(async event => {
        this.requestSubmitted = false;
        this.callingApi = false;
        this.searchHasRun = true;
        console.log("event received from gpt ", event);
        if (event) {
          event = JSON.parse(event);
          if (event["statusCode"] == 200 && event["body"]) {
            let actionIdentified = (event["body"]).toLowerCase();
            actionIdentified = actionIdentified.replace(/^"|"$/g, "");
            if ((event["body"]).toLowerCase() == "none") {
              this.action = null;
              this.actionDetail = null;
              this.requestSubmitted = false;
            }
            else if ((event["body"]).toLowerCase().startsWith("did you mean") || (event["body"]).toLowerCase().startsWith("possible action")) {
              let rcvdText = (event["body"]).toLowerCase();
              rcvdText = rcvdText.replace("did you mean", "");
              rcvdText = rcvdText.replace("possible action", "");
              rcvdText = rcvdText.replace(":", "");
              rcvdText = rcvdText.replace("?", "");
              this.showSuggestion = true;
              this.suggestionText = rcvdText;
              this.action = null;
              this.actionDetail = null;
              this.requestSubmitted = false;
            }
            else {
              let matchIndex = this.actions.findIndex(item => item.label == actionIdentified);
              if (matchIndex != null && matchIndex != -1) {
                this.action = this.actions[matchIndex].value;
                this.actionDetail = this.actionDetails[this.action];
                if (this.actionDetail && this.actionDetail.length > 0) {
                  for (let _i = 0; _i < this.actionDetail.length; _i++) {
                    if (this.actionDetail[_i].webVideoLink) {
                      this.actionDetail[_i].webVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionDetail[_i].webVideoLink);
                    }
                    if (this.actionDetail[_i].appVideoLink) {
                      this.actionDetail[_i].appVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionDetail[_i].appVideoLink);
                    }
                  }
                }
                console.log("action detail is ", this.actionDetail);
              }
            }
          }
        }
      })
        .catch(e => {
          this.callingApi = false;
          this.searchHasRun = true;
          this.requestSubmitted = false;
          console.log("In search error: ", e);
        });
    }
  }

  takeAction(actionName: string) {
    switch (actionName) {
      case 'upload_lead': {
        this.bulkUpload();
        break;
      }
      case 'add_single_lead': {
        this.addSingleLead();
        break;
      }
      case 'create_workspace': {
        this.createOrganzationButtonClicked();
        break;
      }
      case 'invite_user': {
        this.inviteNewUser();
        break;
      }
      case 'remove_user': {
        this.goToUsers();
        break;
      }
      case 'create_team': {
        this.createTeam();
        break;
      }
      case 'view_team': {
        this.goToTeams();
        break;
      }
      case 'export_data': {
        this.goToActiveLeads();
        break;
      }
      case 'view_export': {
        this.goToExports();
        break;
      }
      case 'create_template': {
        this.createTemplate();
        break;
      }
      case 'view_template': {
        this.goToTemplates();
        break;
      }
      case 'create_form': {
        this.createForm();
        break;
      }
      case 'link_form': {
        this.goToForms();
        break;
      }
      case 'view_metrics': {
        this.dialog.close();
        this.router.navigate(['/metrics/performance']);
        break;
      }
      case 'view_source_reports': {
        this.dialog.close();
        this.router.navigate(['/metrics/source-report']);
        break;
      }
      case 'view_attendance': {
        this.dialog.close();
        this.router.navigate(['/metrics/attendance']);
        break;
      }
      case 'view_call_recordings': {
        this.dialog.close();
        this.router.navigate(['/engagements/calls']);
        break;
      }
      case 'create_distribution': {
        this.newLeadDistributionSetup();
        break;
      }
      case 'create_distribution_dynamic': {
        this.newLeadDistributionSetup();
        break;
      }
      case 'edit_user': {
        this.dialog.close();
        this.router.navigate(['/account/profile', { outlets: { 'profile': ['profile-detail'] } }]);
        break;
      }
      case 'integrations': {
        this.goToIntegrations();
        break;
      }
      case 'create_property': {
        this.createProperty();
        break;
      }
    }
  }
  ngOnInit(): void {
    this.createForm_search_activity();

    this.searchForm_activity.get('search_activity').valueChanges.subscribe((searchValue) => {
      this.searchHasRun = false;
    });

    let configData = null;
    if (this.config && this.config.data) {
      configData = this.config.data;
      if (configData.action) {
        this.action = configData.action;
      }

      if (configData.searchValue) {
        this.searchValue = configData.searchValue;
      }

      if (this.action) {
        this.actionDetails = _.cloneDeep(this.actionDetailsOriginal);
        this.actionDetail = this.actionDetails[this.action];
        if (this.actionDetail && this.actionDetail.length > 0) {
          for (let _i = 0; _i < this.actionDetail.length; _i++) {
            if (this.actionDetail[_i].webVideoLink) {
              this.actionDetail[_i].webVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionDetail[_i].webVideoLink);
            }
            if (this.actionDetail[_i].appVideoLink) {
              this.actionDetail[_i].appVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionDetail[_i].appVideoLink);
            }
          }
        }
      }
    }

    this.activeAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        console.log("in dashboard new component, activeAccount is ", this.activeAccount);
        this.channeId = `${this.activeAccount.accountId}__SALESMAX_SUPPORT_ALL`;
        let authLevel = this.activeAccount.authorizationLevel;
        this.allUserMembershipsSubscription = this.dataService.getAllIncludingInactiveUsersInAccount().subscribe((param2: any) => {
          if (param2) {
            this.fetchedUserMemberships = param2;
            this.runAppDiagnostics();
            console.log('All Users Fetched for the account : ', param2);
          }
        });
        if (authLevel == AuthorizationLevel.ADMIN || authLevel == AuthorizationLevel.SUPERADMIN) {
          this.teamMembershipsSubscription = this.dataService.getTeamMemberships().subscribe((param3: any) => {
            if (param3) {
              this.fetchedTeamMemberships = param3;
              console.log('Team Memberships Fetched : ', param3);
            }
          });
          this.teamsSubscription = this.dataService.getTeams().subscribe((param4: any) => {
            if (param4) {
              this.fetchedTeams = param4;
              console.log('Teams Fetched : ', param4);
            }
          });
        }
        else if (authLevel == AuthorizationLevel.MANAGER) {
          this.teamMembershipsSubscription = this.dataService.getDirectReportees().subscribe((param4: any) => {
            if (param4) {
              this.fetchedTeamMemberships = param4;
              console.log('Team Memberships Fetched : ', param4);
            }
          });
          this.teamsSubscription = this.dataService.getDirectTeamsAsTL().subscribe((param4: any) => {
            if (param4) {
              console.log('as Manager teams Fetched : ', param4);
              this.fetchedTeams = param4.map((item) => item.team);;
              console.log('Teams Fetched : ', param4);
            }
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.activeAccountSubscription && !this.activeAccountSubscription.closed)
      this.activeAccountSubscription.unsubscribe();
    if (this.teamMembershipsSubscription && !this.teamMembershipsSubscription.closed)
      this.teamMembershipsSubscription.unsubscribe();
    if (this.teamsSubscription && !this.teamsSubscription.closed)
      this.teamsSubscription.unsubscribe();
    if (this.allUserMembershipsSubscription && !this.allUserMembershipsSubscription.closed)
      this.allUserMembershipsSubscription.unsubscribe();
  }

  bulkUpload() {
    this.dialog?.close();
    this.router.navigate(['/leads/bulk-add-new']);
  }

  addSingleLead() {
    this.dialog?.close();
    this.dialogService.open(AddContactComponent, {}, 0, false);
  }

  viewExports() {
    this.dialog?.close();
    this.router.navigate(['/export/exports']);
  }

  newLeadDistributionSetup() {
    this.dialog?.close();
    this.router.navigate(['/leads/define-distribution']);
  }

  viewProducts() {
    this.dialog?.close();
    this.router.navigate(['/admin/products']);
  }

  inviteNewUser() {
    this.dialog?.close();
    this.dialogService.open(AddEmployeeBulkComponent, {
      data: { accountMembership: this.activeAccount }
    }, 1);
  }

  getStarted() {
    this.dialog?.close();
    this.router.navigate(['/home/get-started']);
  }

  goToIntegrations() {
    this.dialog?.close();
    this.router.navigate(['/admin/integrations', { outlets: { 'integration': ['all-apps'] } }]);
  }

  goToUsers() {
    this.dialog?.close();
    this.router.navigate(['/admin/users']);
  }

  goToAppStatus() {
    this.dialog?.close();
    this.router.navigate(['/admin/users'], { queryParams: { tab: 'app' } });
  }

  private runAppDiagnostics(): void {
    if (!this.fetchedUserMemberships?.length || !this.activeAccount) return;
    const permissionsMap = this.diagnosticService.parseAccountPermissions(this.activeAccount?.account?.permissions);
    const report = this.diagnosticService.diagnoseAll(this.fetchedUserMemberships, permissionsMap);
    this.appIssueCount = report.counts.needsAction + report.counts.notInstalled;
  }

  goToTeams() {
    this.dialog?.close();
    this.router.navigate(['/admin/users'], { queryParams: { tab: 'teams' } });
  }

  goToActiveLeads() {
    this.dialog?.close();
    this.router.navigate(['/leads/all-leads']);
  }

  goToExports() {
    this.dialog?.close();
    this.router.navigate(['/export/exports']);
  }

  goToCustomization() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['customizations'] } }]);
  }

  canCustomizeWorkspace(): boolean {
    return canCustomizeWorkspaceForAccount(this.activeAccount);
  }

  /** Geofence administration is SUPERADMIN-only, so the entry is hidden otherwise. */
  canAdministerGeofences(): boolean {
    return canAdministerGeofencesForAccount(this.activeAccount);
  }

  goToGeofences() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { settings: ['geofences'] } }]);
  }

  goToForms() {
    this.dialog?.close();
    this.router.navigate(['/admin/forms']);
  }

  createProperty() {
    this.dialog?.close();
    this.dialogService.open(CreatePropertyComponent, {

    }, 1);
  }

  createTeam() {
    this.dialog?.close();
    this.dialogService.open(InviteToGroupNewComponent, {
      data: { allUsers: this.fetchedUserMemberships, allTeamMemberships: this.fetchedTeamMemberships, activeAccount: this.activeAccount }
    }, 1);
  }

  createForm() {
    this.dialog?.close();
    this.router.navigate(['/admin/create-form']);
  }

  goToTemplates() {
    this.dialog?.close();
    this.router.navigate(['/admin/templates']);
  }

  goToAccount() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['basic-detail'] } }]);
  }

  manageAccess() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['role-access'] } }]);
  }

  removeDoNotTrack() {
    this.dialog?.close();
    this.router.navigate(['/admin/settings', { outlets: { 'settings': ['do-not-track'] } }]);
  }

  updateAccount() {
    this.dialog?.close('update-account');
  }

  updateAccountDefault() {
    this.dialog?.close('update-account-default');
  }

  createTemplate() {
    this.dialog?.close();
    this.dialogService.open(CreateTemplateComponent, {

    }, 1);
  }

  createOrganzationButtonClicked(): void {
    this.dialog?.close();
    this.router.navigate(['/setup-workspace']);
  }

  connectFacebook() {
    this.dialog?.close("facebook");

  }

  connectIndiamart() {

  }

  quoteSettings() {
    let ref = this.dialogService.open(QuotationDefaultsComponent, { data: {} }, 1);
  }

  openWorkPipelineSetup() {
    this.dialog?.close();
    this.dialogService.open(WorkPipelineSetupComponent, { data: {} }, 1);
  }

  get billingFeatureEnabled(): boolean {
    return isFeatureEnabled('billing', this.activeAccount);
  }

  openBilling(): void {
    if (!this.billingFeatureEnabled) return;
    this.dialog?.close();
    this.router.navigate(['/billing', 'subscription']);
  }

  openWhatsapp() {
    window.open("https://wa.me/919902127389", '_blank');
  }

  openSupportChat() {
    let ref = this.dialogService.open(TeamInboxComponent, {
      data: { selectedChannelId: this.channeId, viewMode: 'dialog-mode' }
    }, 1);
  }


  async showGstTaxIdAlert(initial?: { type?: string; id?: string }): Promise<void> {
    const type: string = initial?.type ?? 'GST';
    const idVal = (initial?.id ?? '').toUpperCase();

    const { value: form } = await Swal.fire({
      title: 'Update Tax ID',
      html: `
      <div style="text-align:left">
        <label for="taxType" class="swal2-label">Tax ID type</label>
        <select id="taxType" class="swal2-select">
          <option value="GST" ${type === 'GST' ? 'selected' : ''}>GST</option>
          <option value="PAN" ${type === 'PAN' ? 'selected' : ''}>PAN</option>
          <option value="TAN" ${type === 'TAN' ? 'selected' : ''}>TAN</option>
          <option value="Other" ${type === 'Other' ? 'selected' : ''}>Other</option>
        </select>

        <label for="taxId" class="swal2-label" style="margin-top:8px;">Tax ID</label>
        <input id="taxId" class="swal2-input" placeholder="Enter GSTIN" value="${idVal}">
        <small id="taxHint" style="display:block;margin-top:4px;color:#6b7280">
          For GST choose your 15-character GSTIN (e.g., 27ABCDE1234F1Z5)
        </small>
      </div>
    `,
      icon: 'info',
      confirmButtonText: 'Save',
      showCancelButton: true,
      focusConfirm: false,
      width: 520,
      didOpen: () => {
        const sel = document.getElementById('taxType') as HTMLSelectElement;
        const inp = document.getElementById('taxId') as HTMLInputElement;
        const hint = document.getElementById('taxHint') as HTMLElement;

        const updateUI = () => {
          const t = sel.value as string;
          inp.placeholder = t === 'GST' ? '15-char GSTIN (e.g., 27ABCDE1234F1Z5)' : `Enter ${t} number`;
          hint.style.display = t === 'GST' ? 'block' : 'none';
        };

        sel.onchange = updateUI;
        inp.oninput = () => { inp.value = inp.value.toUpperCase(); };
        updateUI();
        inp.focus();
      },
      preConfirm: () => {
        const sel = document.getElementById('taxType') as HTMLSelectElement;
        const inp = document.getElementById('taxId') as HTMLInputElement;

        const chosenType = (sel?.value || 'GST') as string;
        const raw = (inp?.value || '').trim().toUpperCase();

        if (!raw) {
          Swal.showValidationMessage('Please enter a tax ID');
          return;
        }

        // Basic GSTIN validation (15 chars)
        if (chosenType === 'GST') {
          if (!isValidGstin(raw)) {
            Swal.showValidationMessage('Please enter a valid 15-character GSTIN (e.g., 27ABCDE1234F1Z5)');
            return;
          }
        }
        return { type: chosenType, id: raw };
      }
    });

    if (form) {
      let input = <UpdateAccountInput>{};
      input.taxId = form.id;
      input.taxIdType = form.type;
      input.id = this.activeAccount.accountId;

      await this.api.UpdateAccount(input).then(event => {
        console.log('Cloud Telephony Account Fetched ', event);
        if (event) {
          Swal.fire({ icon: 'success', title: 'Saved', text: `${form.type} updated.` });
          window.location.reload();
        }
      })
        .catch(e => {
          console.log('Error Updating Tax ID', e);
        });
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    // Close dialog when Ctrl+K is pressed so unified assistant can open on top
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      this.dialog?.close();
    }
  }

  openUnifiedAssistant(query?: string): void {
    this.dialog?.close();

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('open-command-palette', {
        detail: { query: query || '' },
        bubbles: true
      }));
    }, 150);
  }

}
